<template>
  <div class="engineCanvas" ref="engineDiv"></div>
</template>

<script>
import * as THREE from "three";
// 导入轨道控制器
import controls from "@/three/controls";
import gsap from "gsap";
// 导入场景
import scene from "@/three/scene";
// 导入gltf模型加载器
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
// 导入每一帧执行函数
import animate from "@/three/animate";
// 导入相机
import camera from "@/three/camera";
// 导入渲染器
import renderer from "@/three/renderer";
// 初始化屏幕，导入init
import "@/three/init";
export default {
  name: "EngineModel",
  data() {
    return {
      model: null,
      wheelMesh: null,
      spotLight: null,
      directionalLight1: null,
      directionalLight2: null,
      pauseRotation: false
    };
  },
  mounted() {
    this.init();
    // 监听鼠标移入和移出事件
    this.$refs.engineDiv.addEventListener("mouseenter", this.handleMouseEnter);
    this.$refs.engineDiv.addEventListener("mouseleave", this.handleMouseLeave);
    animate();
  },
  beforeDestroy() {
    this.cleanUp();
  },
  methods: {
    init() {
      // 设置相机位置
      camera.position.set(0, 0, 10);
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      // 添加场景
      scene.add(camera);

      // 添加渲染器到dom
      this.$refs.engineDiv.appendChild(renderer.domElement);
      // 设置放大缩小范围
      controls.minDistance = 8;
      controls.maxDistance = 20;
      controls.target.set(0, 2.2, 0);

      // 添加光源
      this.spotLight = new THREE.AmbientLight(0xffffff, 1);
      scene.add(this.spotLight);

      // 添加平行光
      this.directionalLight1 = new THREE.DirectionalLight(0xffffff, 0.5);
      this.directionalLight1.position.set(-50, 50, 50);
      scene.add(this.directionalLight1);
      this.directionalLight2 = new THREE.DirectionalLight(0xffffff, 0.5);
      this.directionalLight2.position.set(50, 50, 50);
      scene.add(this.directionalLight2);
      // 加载模型
      let loader = new GLTFLoader();
      loader.load("./model/ASM-JIANSUQI.ASM.gltf", (gltf) => {
        this.model = gltf.scene;
        this.model.position.set(0, 0, 0);
        this.model.scale.set(0.016, 0.008, 0.012);
        this.model.rotation.y = -Math.PI / 14;
        scene.add(this.model);
        this.rotationAnimation = gsap.to(this.model.rotation, {
          y: (27 * Math.PI) / 14, // 指定履带的位移变化，可根据实际需要调整
          duration: 60, // 动画持续时间，单位秒
          ease: "power1.inOut", // 缓动函数，可根据需要选择
          repeat: -1 // 重复次数，-1表示无限重复
        });
      });
    },
    traverseModel(node) {
      if (node instanceof THREE.Mesh) {
        if (node.name.includes("Obj3d66-1119862-209-188_3")) {
          this.wheelMesh = node;
          return;
        }
      }

      if (node.children && node.children.length > 0) {
        for (const child of node.children) {
          this.traverseModel(child);
        }
      }
    },
    

    cleanUp() {
      if (this.model) {
        scene.remove(this.model);
      }
      if (this.spotLight) {
        scene.remove(this.spotLight);
      }
      if (this.directionalLight1) {
        scene.remove(this.directionalLight1);
      }
      if (this.directionalLight2) {
        scene.remove(this.directionalLight2);
      }
      this.$refs.engineDiv.removeEventListener('mouseenter', this.handleMouseEnter);
  this.$refs.engineDiv.removeEventListener('mouseleave', this.handleMouseLeave);
      scene.remove(camera);
      renderer.dispose();
    },
    handleMouseEnter() {
      this.pauseRotation = true; // 暂停旋转动画
      if (this.rotationAnimation) {
        this.rotationAnimation.pause(); // 暂停 gsap 动画
      }
    },
    handleMouseLeave() {
      this.pauseRotation = false; // 恢复旋转动画
      if (this.rotationAnimation) {
        this.rotationAnimation.resume(); // 恢复 gsap 动画
      }
    },
  }
};
</script>

<style scoped>
.engineCanvas {
  position: absolute;
  top: 90px;
  right: 0;
}
</style>
